import {FC, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import {NavigationCardConfig} from '../types';

export type NavigationCardProps = {
  cardConfig: NavigationCardConfig,
}

const NavigationCard: FC<NavigationCardProps> = ({
  cardConfig: {type, icon, path, isExternalLink}
}) => {
  const {t} = useTranslation('dashboard');
  const history = useHistory();

  const handleClick = useCallback(() => {
    if (!isExternalLink) {
      history.push(path);
    } else {
      window.open(path, '_blank')?.focus();
    }
  }, [path, isExternalLink]);

  return (
    <div className={`card ${type}`} onClick={handleClick}>
      <div className="card__icon">
        {icon && <img src={icon} alt={type} />}
      </div>
      <div className="card__label">{t(`navigationCards.${type}`)}</div>
    </div>
  );
};

export default NavigationCard;
